import { textWithHTML } from 'Data/format.js'

export function getText() {
  return textWithHTML(
    `Select the appropriate <b>CDT code</b>, and indicate if <b>tooth #</b> and <b>surface</b> details are needed.`
  )
}
